import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CategoriesShowCard from "../../Components/CategoriesShowCard/CategoriesShowCard";
import Loading from "../../Components/Loading/Loading";
import MainLoading from "../../Components/Loading/MainLoading";
import PlayerShowCard from "../../Components/PlayerShowCard/PlayerShowCard";
import { getMoreInfo, getOverlay } from "../../Redux/MoreInfo/moreInfoSlice";
import { getRandomItem } from "../../utils/utils";
import Categories from "./Components/Categories";
import Featured from "./Components/Featured";
import Live from "./Components/Live";
import MoreTopics from "./Components/MoreTopics";
import * as service from "./service";
import "animate.css";
import { useLocation, useParams } from "react-router-dom";
import DetailScreenModal from "../ShowDetailsScreen/DetailScreenModal";
import { getHomeData } from "../../Redux/HomeData/homeDataSlice";
import { getEventMoreInfo } from "../../Redux/MoreInfo/eventMoreInfoSlice";
import EventDetailsScreenModal from "../EventDetailsScreenModal/EventDetailsScreenModal";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import { useNavigate } from "react-router-dom/dist";
import HomePagelive from "./Components/HomePagelive";
import TopTrendingEpisodes from "../../Components/TopTrending/TopTrendingEpisodes";
import LiveChannels from "../LiveChannels/LiveChannels";
import Genres from "./Components/Genres";

const Homepage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const homeCollection = useSelector((state) => state?.homeData?.value);
  const isMoreInfo = useSelector((state) => state?.moreInfo?.value);
  const isEventMoreInfo = useSelector((state) => state?.eventMoreInfo?.value);
  const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);

  const [featured, setFeatured] = useState()
  const [loading, setLoading] = useState(true);
  const [homeData, setHomeData] = useState([]);
  const [homeDataSliceCount, setHomeDataSliceCount] = useState(8);
  // const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [fontClass, setFontClass] = useState("");
  const dispatch = useDispatch()
  const location = useLocation()
  const homePageContainerRef = useRef()
  const scrollPosition = useScrollPosition();

  let fontStylesClassName = ["gagalin", "gota"];
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  const navigate = useNavigate()
  const pubid  = projectInfo?.projectConfig?.pubid;
  const params = useParams();
  const keyFromRoute = location?.state?.key || params?.key;
  // useEffect(() => {
  //   if (isOverlay) {
  //     const { descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [isOverlay]);
  useEffect(() => {
    if (projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true") {
      if (userDetails?.language_id === null || !userDetails?.language_id || userDetails?.language_id === "") {
        navigate("/language-selection")
        localStorage.setItem("redirectURL", "/home")
      }
    }
  }, [userDetails])

  useEffect(() => {
    setLoading(true);
    fetchShowDetails(keyFromRoute);
    setFontClass(getRandomItem(fontStylesClassName));
  }, [user, keyFromRoute]);

  useEffect(() => {
    if (!loading && homeDataSliceCount < homeData?.length) {
      lazyLoad()
    }
  }, [loading, scrollPosition, homeData])

  useEffect(() => {
    if (homeCollection?.length > 0) {
      setHomeData(homeCollection)
    }
  }, [homeCollection])
  // useEffect(() => {
  //   if (
  //     projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT"
  //   ) {
  //     setThumbnailOrientation("PORTRAIT");
  //   } else {
  //     setThumbnailOrientation("LANDSCAPE");
  //   }
  // }, [projectInfo]);
  useEffect(() => {
    if (location?.pathname) {
      let id = location?.pathname.split("/")[2];
      let path = location?.pathname.split("/")[1];
      if (id !== "null" && id !== "undefined" && id && path === "show-details") {
        dispatch(
          getMoreInfo({
            moreInfo: true,
          })
        )
      }
      else if (id !== "null" && id !== "undefined" && id && path === "event") {
        dispatch(
          getEventMoreInfo({
            eventMoreInfo: {
              isModal: true
            },
          })
        )
      }
    }
  }, [location?.pathname]);





  // useEffect(() => {
  //   if(isOverlay){

  //     let handleOutClick = (e) => {
  //       if (
  //         !showInfoRef?.current?.contains(e.target) &&
  //         showInfoContainerRef?.current?.contains(e.target)
  //       ) {
  //         document.body.style.overflow="unset"

  //         dispatch(getOverlay({
  //           overalay:false
  //         }))
  //       }
  //     };
  //     window.addEventListener("click", handleOutClick);
  //   }
  // }, [isOverlay]);
  const fetchShowDetails = async (key) => {
    try {
      const response = await service.getShowsByCategory(appInfo, key);
      if (response?.status === 200) {
        setFeatured(response?.data?.data?.find(item => item.type === "FEATURED"))
        dispatch(
          getHomeData({
            homeData: response?.data?.data
          })
        )
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const bottomOfPageRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (
        bottomOfPageRef.current?.getBoundingClientRect().top <=
        window.innerHeight
      ) {
        console.log("User has reached the end of the window!");
        // You can trigger any actions you need here
      }
    };


    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const lazyLoad = () => {
    const containerHeight = homePageContainerRef?.current?.clientHeight;
    if (scrollPosition + 2500 >= containerHeight) {
      setHomeDataSliceCount(homeDataSliceCount + 5)
    }
  }

  const loadMoreHandler = () => {
    setHomeDataSliceCount(homeDataSliceCount + 10)
  }

  if (loading) {
    return <MainLoading />;
  }



  return (
      <div className="homePage" ref={homePageContainerRef}>
        {/* {
        isOverlay&&
      <div className="overlay" onClick={()=>overlayHandler()}></div>
      } */}
        {
          isMoreInfo && !isMoreInfoOther?.isFromSearch &&
          <DetailScreenModal fetchHomeData={fetchShowDetails} />
        }
        {
          isEventMoreInfo?.isModal &&
          <EventDetailsScreenModal />
        }
        {/* <div className={isOverlay?"showInformationContainer active":"showInformationContainer"} ref={showInfoContainerRef}>
        <div onAnimationEnd={} className="info " ref={showInfoRef}>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus sequi aut alias error labore, nobis quisquam earum optio neque quis cupiditate cumque quasi nulla, at porro facilis! Laudantium explicabo quasi neque veritatis eveniet, illum distinctio a. Voluptatibus quam eius minima totam doloremque praesentium fugiat tempore voluptates! Recusandae nam officiis cumque tempora ipsum! Est laboriosam at labore eligendi adipisci. Voluptas sapiente nostrum necessitatibus odio perspiciatis, tenetur accusantium eos repellendus at inventore doloremque vel cupiditate temporibus iure? Vero ipsa corporis quos error ea minima veniam tempore ab animi voluptatem molestiae neque dignissimos asperiores voluptatum unde fuga, aperiam cupiditate nulla ratione enim sapiente quam libero. Dolor deleniti quia officia minima officiis, possimus expedita eos placeat. Distinctio minima sequi a nulla. Dignissimos, molestiae, officia porro sunt rem unde quae expedita asperiores quisquam dolore cumque eligendi doloribus similique quo dicta velit veritatis, incidunt dolorum cupiditate. Laboriosam eaque nesciunt in ad dignissimos voluptatem itaque. Quas dolores deleniti quos consectetur voluptatum eos, et nam sequi quibusdam laudantium culpa pariatur, illum distinctio. Excepturi voluptates, ipsam sint maiores rem deserunt laudantium repellat iure necessitatibus fuga dolores, minima quaerat totam eligendi eum. Quis laboriosam explicabo laudantium accusantium totam deserunt dolore aspernatur quia id quam ipsum, illum asperiores voluptates vitae dolores numquam molestiae provident nostrum obcaecati. Magnam adipisci voluptatem iure nostrum pariatur quae, eveniet eum aliquam magni! Aliquid eaque voluptas, mollitia, sequi natus consequatur, esse dicta iure porro aliquam blanditiis. Impedit repellendus harum cumque, unde exercitationem velit sit dolorem. Autem commodi voluptas repudiandae! Sint omnis illum mollitia atque, voluptatibus sed possimus fugiat? Dolore doloribus mollitia consequuntur expedita atque voluptatem cupiditate dolor? Sapiente, voluptas a hic dignissimos architecto ab ex expedita rerum ea quibusdam illum distinctio? Illo saepe odio mollitia quasi eos pariatur, aliquam consequuntur eum ratione, voluptatum fuga culpa quae harum exercitationem quis! Saepe, odio illo. Assumenda maiores quis labore quod corporis commodi tempore debitis deleniti! Necessitatibus ut, expedita ullam corrupti itaque exercitationem impedit explicabo porro, odio neque quos eaque nihil dolorum illo amet. Quos neque ut iure commodi, obcaecati error cumque eum beatae cupiditate, velit est modi dolorem. Facilis illum quia obcaecati accusantium incidunt. Quae et nostrum, architecto, quod reprehenderit vero, similique tenetur inventore id praesentium a nihil maxime qui? Inventore maxime natus odio et ratione sunt vero mollitia expedita amet dolores consequuntur a ipsum, illum voluptas eum enim quam eius, minus libero ut commodi debitis eos aspernatur ipsam. Provident exercitationem nam quis! Officia ex saepe, repellendus dolorum facere quia non qui, in dolore hic facilis optio dolores! Numquam nobis dolorem a possimus mollitia consectetur itaque eius perspiciatis sunt. Magni laudantium reprehenderit eaque ipsum beatae facilis aliquam pariatur sint illum dolore dolorem nostrum dignissimos neque necessitatibus iusto iste rem, ipsa delectus culpa voluptatum quam! Numquam id perferendis nulla commodi quo accusantium. Rerum optio nostrum esse placeat quibusdam, blanditiis magni quia, adipisci amet ad dolores, autem earum maxime. Odit enim error nesciunt minus repudiandae, quisquam, eligendi sunt distinctio aspernatur ratione repellat ad ducimus. Corrupti, maxime repudiandae commodi accusamus consequatur possimus ipsa nemo? Deserunt tempore cupiditate nemo deleniti, laudantium magni, nobis pariatur unde ipsam ad cum voluptates animi repellendus aspernatur inventore saepe fuga officia aperiam enim! Ipsa necessitatibus aut quae reiciendis perspiciatis, praesentium architecto ipsam consequatur labore similique unde ullam doloribus pariatur corrupti facilis commodi modi eaque accusamus culpa? Optio dolorum voluptas maxime fugit recusandae architecto cumque possimus unde provident accusantium deleniti, tempora doloribus officiis inventore eveniet ad quisquam quos similique suscipit obcaecati iure doloremque itaque rem! Temporibus tempore aliquid reprehenderit harum dolorum voluptatum quas nobis odit mollitia ipsa, repellat voluptates sint ea at praesentium incidunt neque assumenda suscipit nihil ducimus vero, fuga, alias quae enim. Sequi dicta dolores quo laboriosam, consectetur explicabo voluptatum quae ratione hic quia voluptatem error, deserunt cum. Odio dolor quaerat, ad, aliquam officia, autem deleniti a nostrum minus fuga error voluptatum. Debitis, soluta numquam iste eum nihil facere fuga sit culpa veniam quos dolorem. Iusto earum tempora labore nisi officiis tempore, quidem atque animi ab blanditiis! Dolorum qui quia tempora eaque dicta, eum quam et mollitia corrupti fugiat incidunt. Perspiciatis aliquid nemo mollitia, culpa laborum ullam tenetur asperiores nihil magnam molestiae facere numquam illo, eveniet iste dolore exercitationem, non enim? Repellat illum, tempore molestias, consequuntur odio hic rerum, expedita quas consequatur voluptatem accusamus perferendis quo voluptates iusto officia ea? Totam, delectus ea necessitatibus possimus cum maiores quos rem modi consectetur, cumque voluptates laboriosam aut illum, tempore fugit ad quia ipsam hic tenetur. Cupiditate tenetur, corrupti illum maiores dignissimos harum quia labore veritatis suscipit consectetur, sunt enim exercitationem. Ad temporibus aliquid deleniti assumenda doloribus, repellat nihil doloremque nisi enim, necessitatibus aspernatur nulla ex non sunt similique iure natus exercitationem, aliquam neque cum. Vel quasi iusto ut aliquid fugiat quam, rerum perspiciatis ipsam non numquam cumque ullam ipsa laboriosam esse perferendis nemo sequi? Velit qui voluptatibus quod beatae tempora nihil magni incidunt accusantium porro modi consequuntur voluptatum, laborum quae impedit nostrum delectus doloribus vitae dolore. Nisi ipsum officia, tempore ullam beatae corporis sapiente impedit incidunt eum est similique qui. Ut delectus sint laboriosam odio deserunt enim voluptatum nihil? In, dignissimos? A quae eligendi, placeat soluta odit cumque voluptatibus architecto labore vel assumenda voluptatum, molestiae ipsa! Hic cum culpa autem, illum id earum deleniti voluptates reprehenderit magni ab, magnam sit suscipit obcaecati, in ipsam dolor aperiam. Doloremque odio expedita, vero minus vel eos explicabo culpa assumenda neque quae sapiente voluptatibus, asperiores nobis, harum soluta natus sit dolor nostrum quo ex consectetur unde quam. Laborum repudiandae reprehenderit facilis quis accusantium, mollitia, inventore labore quibusdam, laboriosam illum eaque praesentium eveniet sapiente? Sapiente alias assumenda, sint velit optio molestiae cumque voluptate sit eligendi aliquid, quaerat temporibus quos molestias atque quia enim culpa odit voluptas, reiciendis dolorum ipsa fugit aliquam? Necessitatibus sit facere aspernatur, laboriosam voluptatem ducimus laudantium eum harum aliquid mollitia animi maiores, explicabo excepturi eius minima sunt doloremque perferendis ab atque odio neque labore voluptatibus reprehenderit. Quo voluptates aliquam totam commodi nemo cupiditate deleniti maiores sint placeat, quia quis temporibus corporis eligendi vitae eius quaerat perferendis molestiae exercitationem rerum quas magni! Odit placeat necessitatibus excepturi tenetur veniam illum alias ea obcaecati tempora!</p>
        </div>
      </div> */}
        {
          homeData?.slice(0, homeDataSliceCount).map((item, index) => {
            if (item?.type === "FEATURED") {
              // if (pubid === 50057) {
              //   return <LiveChannels key={"livechannels-homepage"} hideEpg={true} />;
              // }
              return <Featured key={index} fontClass={fontClass} data={item} />;
            }
            else if (item?.type === "LIVE"){
              // return  <HomePagelive  data={item}/>
              return <LiveChannels key={"livechannels-homepage"} hideEpg={true} />;
            }
            // else if (item?.type !== "LIVE") {
            //   return (
            //     <Categories
            //       key={index}
            //       data={item}
            //       thumbnailOrientation={thumbnailOrientation}
            //       type={item?.type}
            //       lastChild={index+1===homeData?.length?true:false}
            //     />
            //   );
            // }
          })}
        <div className={featured ? "allCategories" : "allCategoriesWithoutBanner"}
            // style={pubid === 50057 ? { marginTop: "200px" } : {}}
>
          {
            homeData?.slice(0, homeDataSliceCount).map((item, index) => {
              if (item?.type === "GENRES") {
                return (
                  <Genres key={index} data={item} />
                )
              } 
              else if (item?.type === "MORE_TOPICS") {
                return (
                  <MoreTopics key={index} data={item} />
                )
              }
              else if (item?.type !== "FEATURED" && item?.type !== "LIVE") {
                return (
                  <Categories
                    key={index}
                    data={item}
                    // thumbnailOrientation={thumbnailOrientation}
                    type={item?.type}
                    lastChild={index + 1 === homeData?.length ? true : false}
                  />
                )
              }
            })
          }

        </div>
        {/* {
        homeDataSliceCount<homeData?.length&&
      <div className="LoadMoreButtonContainer">
        <button onClick={loadMoreHandler}>Load More</button>
      </div>
      } */}
        <div ref={bottomOfPageRef} />
      </div>
  );
};

export default Homepage;
